'use strict';

import Component from 'generic.basecomponent';
import fontFinally from 'font-loader';
import app, {DEVICE_TYPE_MOBILE} from '../../../general/js/app-instance';

export default class HeroImage extends Component {
    constructor(el) {
        super(el);
        this.init();
        this.headerHeight = 41;
        this.backgroundContentTopOffset = 235;
        this.hasPositioned = false;
    }

    init() {
        this.widget = this.container.querySelector('.js-hero-image-widget');
        this.background = this.container.querySelector('.js-hero-image-background');
        if (!this.widget || !this.background) {
            return;
        }

        fontFinally.then(() => {

            setTimeout(() => {
                this.widget.style.height = 'auto';
                this.handlePosition();

                app.addListener('resize:finished', () => {
                    this.handlePosition();
                });

                app.addListener('device-type-changed', (old, newDevice) => {
                    if (newDevice === DEVICE_TYPE_MOBILE) {
                        this.resetPosition();
                    }
                });
                //fucking safari delay of font applying  -___-
            }, 200)

        });
    }

    handlePosition() {
        if (app.isTablet) {
            let hasPositioned = this.handleTopAlignWidgetPosition();
            if (!hasPositioned) {
                this.handleBottomAlignWidgetPosition();
            }
        }
    }

    resetPosition() {
        if (this.hasPositioned) {
            this.hasPositioned = false;
            this.background.style.minHeight = '0';
        }
    }

    getBottomEdgeOffset(elem) {
        let box = elem.getBoundingClientRect();
        let menuHeight = app.isDesktop ? this.headerHeight : 0;
        return (box.bottom + pageYOffset) - menuHeight;
    }

    getTopEdgeOffset(elem) {
        let box = elem.getBoundingClientRect();
        let menuHeight = app.isDesktop ? this.headerHeight : 0;
        return (box.top + pageYOffset) - menuHeight;
    }

    handleTopAlignWidgetPosition() {
        let backgroundBottomEdge = this.getBottomEdgeOffset(this.background);
        let widgetBottomEdge = this.getBottomEdgeOffset(this.widget);
        if ((widgetBottomEdge > backgroundBottomEdge) && !this.hasPositioned) {
            this.hasPositioned = true;
            this.background.style.minHeight = `${widgetBottomEdge}px`;
            return true;
        }
        return false;
    }

    handleBottomAlignWidgetPosition() {
        let widgetTopEdge = this.getTopEdgeOffset(this.widget);
        if ((widgetTopEdge < this.backgroundContentTopOffset) && !this.hasPositioned) {
            this.hasPositioned = true;
            let backgroundBottomEdge = this.getBottomEdgeOffset(this.background);
            this.background.style.minHeight = `${backgroundBottomEdge + (this.backgroundContentTopOffset - widgetTopEdge)}px`;
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./app/components/hero-image/js/generic.hero-image.js